import { render, staticRenderFns } from "./SegmentPickerDialog.vue?vue&type=template&id=8808148e&scoped=true"
import script from "./SegmentPickerDialog.vue?vue&type=script&lang=js"
export * from "./SegmentPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./SegmentPickerDialog.vue?vue&type=style&index=0&id=8808148e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808148e",
  null
  
)

export default component.exports